/**
 * Maps through an array of objects and ensures the value property is set.
 * If the value property is not set, it will use the description property as fallback.
 * Works with any object type similar to IListItem that has optional value and description properties.
 *
 * @param items - Array of objects to map (e.g., IListItem or similar)
 * @returns Mapped array with value property ensured
 * @example
 * const items = [{ id: '1', description: 'Item 1', status: 'active' }];
 * const mapped = mapValueProperty(items); // value will be set to 'Item 1'
 */
export function mapValueProperty<T extends Record<string, any>>(items: T[]): T[] {
  return items.map((item) => ({
    ...item,
    status: typeof item.status === 'string' ? item.status : String(item.status),
    value: <string>(item.value || item.description),
    label: <string>(item.value || item.description),
  }));
}
